export const VIEW_DASHBOARD_PERMISSION = "view_dashboard";

export const VIEW_ACCOUNTS_PERMISSION = "view_accounts";

export const CREATE_IPMP_PERMISSION = "create_ipmp";
export const UPDATE_IPMP_PERMISSION = "update_ipmp";
export const DELETE_IPMP_PERMISSION = "delete_ipmp";

export const FORCE_SYNC_PERMISSION = "force_sync";
export const UPDATE_OTT_PERMISSION = "update_ott";
export const DELETE_OTT_PERMISSION = "delete_ott";

export const VIEW_ACCOUNT_REGISTERED_PERMISSION = "view_account_registered";
export const VIEW_ACCOUNT_LICENSE_PERMISSION = "view_account_license";
export const VIEW_ACCOUNT_SYSTEM_EVENTS_PERMISSION =
  "view_account_system_events";
export const VIEW_ACCOUNT_FILES_PERMISSION = "view_account_files";
export const VIEW_ACCOUNT_PUSH_CENTERS_PERMISSION = "view_account_push_centers";
export const VIEW_ACCOUNT_PACKAGES_PERMISSION = "view_account_packages";
export const VIEW_ACCOUNT_DASHBOARD_PERMISSION = "view_account_dashboards";

export const CREATE_DELETE_UPDATE_ACCOUNT_NOTE_PERMISSION =
  "create_update_delete_note";

export const CREATE_ANTIVIRUS_LICENSE_PERMISSION =
  "create_antivirus_license_file";
export const CREATE_ACCOUNT_CERT_PERMISSION = "create_cert_file";
export const CREATE_ACCOUNT_ICON_PERMISSION = "create_icon";
export const CREATE_ACCOUNT_EMAIL_TEMPLATE_PERMISSION = "create_email_template";
export const CREATE_ACCOUNT_IQ_CONFIG_PERMISSION = "create_iq_config_file_ipmp";
export const CREATE_ACCOUNT_EVENTS_PERMISSION = "create_event_file_ipmp";
export const CREATE_ACCOUNT_NEO_XML_PERMISSION = "create_neo_xml_file_ipmp";
export const CREATE_ACCOUNT_IQ_PATH_TAGS_PERMISSION =
  "create_iq_patch_tags_ipmp";
export const CREATE_ACCOUNT_IQ_CONFIG_SCHEMA_PERMISSION =
  "create_iq_config_schema";
export const CREATE_ACCOUNT_APP_CUSTOMIZATION_PERMISSION =
  "create_app_customization";
export const CREATE_ACCOUNT_DEFAULT_CUSTOMIZATION_PERMISSION =
  "create_default_customization";

export const UPDATE_ACCOUNT_IQ_PATCH_TAGS_PERMISSION =
  "update_iq_patch_tags_ipmp";
export const UPDATE_LICENSE_RENEWAL_PERMISSION = "update_license_renewal";
export const UPDATE_DEALER_INFO_PERMISSION = "update_dealer_info";

export const DELETE_ANTIVIRUS_LICENSE_PERMISSION =
  "delete_antivirus_license_file";
export const DELETE_ACCOUNT_CERT_PERMISSION = "delete_cert_file";
export const DOWNLOAD_ACCOUNT_CERT_PERMISSION = "download_cert_file";
export const DELETE_ACCOUNT_ICON_PERMISSION = "delete_icon";
export const DELETE_ACCOUNT_EMAIL_TEMPLATE_PERMISSION = "delete_email_template";
export const DELETE_ACCOUNT_IQ_CONFIG_PERMISSION = "delete_iq_config_file_ipmp";
export const DELETE_ACCOUNT_EVENTS_PERMISSION = "delete_event_file_ipmp";
export const DELETE_ACCOUNT_NEO_XML_PERMISSION = "delete_neo_xml_file_ipmp";
export const DELETE_ACCOUNT_IQ_PATCH_TAGS_PERMISSION =
  "delete_iq_patch_tags_ipmp";
export const DELETE_ACCOUNT_CUSTOMIZATION_PERMISSION = "delete_customization";
export const DELETE_ACCOUNT_IQ_CONFIG_SCHEMA_PERMISSION =
  "delete_iq_config_schema";
export const UPDATE_ACCOUNT_APP_PERMISSION = "update_app_customization";

export const VIEW_LICENSE_TEMPLATE_PERMISSION = "view_license_templates";
export const CREATE_LICENSE_TEMPLATE_PERMISSION = "create_license_template";
export const UPDATE_LICENSE_TEMPLATE_PERMISSION = "update_license_template";
export const DELETE_LICENSE_TEMPLATE_PERMISSION = "delete_license_template";

export const VIEW_LICENSE_LIMIT_PERMISSION = "view_license_limits";
export const CREATE_DEFAULT_LIMIT_PERMISSION = "create_license_limit_type";
export const UPDATE_DEFAULT_LIMIT_PERMISSION = "update_license_limit_type";
export const DELETE_DEFAULT_LIMIT_PERMISSION = "delete_license_limit_type";

export const VIEW_LICENSE_FEATURES_PERMISSION = "view_license_features";
export const CREATE_DEFAULT_FEATURE_GROUP_PERMISSION = "create_feature_group";
export const DELETE_DEFAULT_FEATURE_GROUP_PERMISSION = "delete_feature_group";
export const CREATE_DEFAULT_FEATURE_TYPE_PERMISSION = "create_feature_type";
export const UPDATE_DEFAULT_FEATURE_TYPE_PERMISSION = "update_feature_type";
export const DELETE_DEFAULT_FEATURE_TYPE_PERMISSION = "delete_feature_type";

export const CREATE_XML_PERMISSION = "create_xml_file";
export const DELETE_XML_PERMISSION = "delete_xml_file";

export const CREATE_VERSION_EMAIL_TEMPLATE_PERMISSION =
  "create_email_template_file_version";
export const CREATE_VERSION_IQ_CONFIG_PERMISSION =
  "create_iq_config_file_version";
export const CREATE_VERSION_EVENTS_PERMISSION = "create_event_file_version";
export const CREATE_VERSION_IQ_PATCH_TAGS_PERMISSION =
  "create_iq_patch_tags_version";
export const CREATE_DELETE_VERSION_ASSIGN_XML_PERMISSION =
  "create_delete_assign_xml";

export const DELETE_VERSION_EMAIL_TEMPLATE_PERMISSION =
  "delete_email_template_file_version";
export const DELETE_VERSION_IQ_CONFIG_PERMISSION =
  "delete_iq_config_file_version";
export const DELETE_VERSION_EVENTS_PERMISSION = "delete_event_file_version";
export const DELETE_VERSION_IQ_PATCH_TAGS_PERMISSION =
  "delete_iq_patch_tags_version";

export const UPDATE_VERSION_IQ_PATCH_TAGS_PERMISSION =
  "update_iq_patch_tags_version";

export const VIEW_IU_VERSIONS_PERMISSION = "view_incremental_upgrade_versions";

export const CREATE_IU_VERSION_PERMISSION =
  "create_incremental_upgrade_version";
export const CREATE_IU_FILES_PERMISSION = "create_incremental_upgrade_files";

export const DELETE_IU_VERSION_PERMISSION =
  "delete_incremental_upgrade_version";
export const DELETE_IU_FILES_PERMISSION = "delete_incremental_upgrade_files";

export const SHOW_XMLs_PERMISSION = "view_essentials_xml";
export const CREATE_ESSENTIALS_VERSION_PERMISSION = "create_essentials_version";
export const DELETE_ESSENTIALS_VERSION_PERMISSION = "delete_essentials_version";

export const CREATE_LOCALE_PERMISSION = "create_locale";
export const DELETE_LOCALE_PERMISSION = "delete_locale";

export const CREATE_LOCALE_FILE_PERMISSION = "create_locale_file";
export const DELETE_LOCALE_FILE_PERMISSION = "delete_locale_file";

export const VIEW_PANEL_UPGRADE_PACKAGES = "view_panel_upgrade_packages";
export const CREATE_PACKAGE_FILE_PERMISSION = "create_package_file";
export const DELETE_PACKAGE_FILE_PERMISSION = "delete_package_file";
export const CREATE_DELETE_ASSIGN_PACKAGE_FILE_PERMISSION =
  "create_delete_assign_package";

export const CREATE_OTA_HMAC_PERMISSION = "create_ota_hmac";
export const UPDATE_OTA_HMAC_PERMISSION = "update_ota_hmac";
export const DELETE_OTA_HMAC_PERMISSION = "delete_ota_hmac";

export const CREATE_APNS_CENTER_PERMISSION = "create_apns_center";
export const CREATE_FCM_CENTER_PERMISSION = "create_fcm_center";
export const DELETE_APNS_CENTER_PERMISSION = "delete_apns_center";
export const DELETE_FCM_CENTER_PERMISSION = "delete_fcm_center";
export const CREATE_DELETE_ASSIGN_CENTER_PERMISSION =
  "create_delete_assign_center";

export const VIEW_ACTION_LOG_PERMISSION = "view_action_log";

export const VIEW_SETTINGS_SYSTEM_EVENTS = "view_settings_system_events";
export const VIEW_SETTINGS_USERS = "view_settings_users";
export const VIEW_SETTINGS_SERVICES = "view_service";
export const VIEW_SETTINGS_SERVERS = "view_server_settings";
export const UPDATE_OKTA_SETTINGS = "update_okta_settings";
export const UPDATE_SMTP_SETTINGS = "update_smtp_settings";
export const UPDATE_ACTION_LOG_SETTINGS = "update_action_log_settings";
export const UPDATE_FTP_SETTINGS = "update_ftp_settings";

export const CREATE_USER_PERMISSION = "create_user";
export const UPDATE_USER_PERMISSION = "update_user";
export const DELETE_USER_PERMISSION = "delete_user";

export const VIEW_SETTINGS_GROUPS = "view_settings_groups";
export const CREATE_GROUP_PERMISSION = "create_group";
export const DELETE_GROUP_PERMISSION = "delete_group";

export const VIEW_SETTINGS_TLS = "view_settings_tls";
